import React from 'react';
import styled from 'styled-components';
import { GroupMemberContentMode } from '../../../shared/enum/EnumRepository';
import { useGroupMemberContentModeStore } from '../../../shared/store/groupMemberContentModeStore';
import { useEditMode } from '../../../shared/hooks/useEditMode';

const GroupMemberTopBarMobile: React.FC = () => {
  const { isEditMode } = useEditMode();
  const groupMemberContentMode = useGroupMemberContentModeStore(
    (s) => s.groupMemberContentMode,
  );
  const setGroupMemberContentMode = useGroupMemberContentModeStore(
    (s) => s.setGroupMemberContentMode,
  );
  const isEngMode = groupMemberContentMode === GroupMemberContentMode.ENG;

  const handleToggleLanguage = () => {
    setGroupMemberContentMode(
      isEngMode ? GroupMemberContentMode.Orig : GroupMemberContentMode.ENG,
    );
  };

  return (
    <TopBar>
      <LanguageSelector>
        {isEditMode ? (
          <>
            <LanguageOption
              type="button"
              $isActive={groupMemberContentMode === GroupMemberContentMode.Orig}
              onClick={() => setGroupMemberContentMode(GroupMemberContentMode.Orig)}
            >
              Orig
            </LanguageOption>
            <LanguageDivider>/</LanguageDivider>
            <LanguageOption
              type="button"
              $isActive={isEngMode}
              onClick={() => setGroupMemberContentMode(GroupMemberContentMode.ENG)}
            >
              ENG
            </LanguageOption>
          </>
        ) : (
          <LanguageOption
            type="button"
            $isActive={isEngMode}
            onClick={handleToggleLanguage}
          >
            {isEngMode ? 'ENG' : 'Orig'}
          </LanguageOption>
        )}
      </LanguageSelector>
    </TopBar>
  );
};

export default GroupMemberTopBarMobile;

const TopBar = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
`;

const LanguageSelector = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

const LanguageOption = styled.button<{ $isActive: boolean }>`
  ${({ theme }) => theme.typography.Footer_01};
  color: ${({ theme, $isActive }) =>
    $isActive ? theme.colors.color_Gray_04 : theme.colors.color_Gray_05};
  background-color: transparent;
  border: none;
  cursor: pointer;
  transition: color 0.2s ease;
  padding: 0;

  &:hover {
    color: ${({ theme }) => theme.colors.color_Gray_04};
  }
`;

const LanguageDivider = styled.span`
  ${({ theme }) => theme.typography.Footer_01};
  color: ${({ theme }) => theme.colors.color_Gray_05};
  user-select: none;
`;
